// Global Utility Functions
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// Cart

class Cart {
  constructor() {}
  
  /*
    Add items:
      By variant id:
        items: [
        {
          'id': 794864053,
          'quantity': 3
        }
      ],
      sections: 'cart-count,cart-items'

      By line number:
      items: [
        {
          'line': 1,
          'quantity': 3
        }
      ],
      sections: 'cart-count,cart-items'
  */

  async addItems(items) {
    console.log('items',items);
    return fetch(window.shop_api.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(items)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data.status === 422) return;
      // console.info('Add items success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  async updateItems(update) {
    return fetch(window.shop_api.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(update)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 422) return;
      console.log('Update items success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  async changeItems(update) {
    return fetch(window.shop_api.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(update)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 422) return;
      console.log('Change items success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

const CartJS = new Cart();

// document.addEventListener('rebuy:cart.add', (event) => {
//   // console.log('rebuy:cart.add event', event.detail);
// });

// Cart ready
// document.addEventListener('rebuy:cart.ready', (event) => { 
//   // console.log('rebuy:cart.ready event', event.detail); 
// });

// Cart change
document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail);
  const { cart } = event.detail.cart;
  const itemCount = cart.item_count;
  document.querySelector('.cart-count').innerText = itemCount;
  if (itemCount === 0) {
    document.querySelector('.cart-count').style.display = 'none';
  } else {
    document.querySelector('.cart-count').style.display = 'inline-block';
  }
});

document.querySelectorAll('[data-product-card-option]').forEach(el => {
  el.addEventListener('change', (event) => {
    const productId = el.dataset.productId;
    const available = el.dataset.variantAvailable;
    if (JSON.parse(available)) {
      document.querySelector(`[data-product-card-actions="${productId}"]`).classList.remove('oos');
    } else {
      document.querySelector(`[data-product-card-actions="${productId}"]`).classList.add('oos');
    }
  });
});